import ImportAndExportPage from './ImportAndExportPage';
import Locale  from './Locale';
import Forbidden from './Forbidden';
import Home from './Home';
import Login from './Login';
import NotFound from './NotFound';

const Pages = {
  ImportAndExportPage,
  Locale,
  Forbidden,
  Home,
  Login,
  NotFound
}

export default Pages;
